// extracted by mini-css-extract-plugin
export default {"dropdown":"QODZK","button":"KFR5H","buttonActionText":"D0nPZ"};